import {invoke} from './api';
import env from './config';
import {
  deviceStatusQuery,
  devicesQuery,
  pipelineExecutionsQuery,
  getLinesQuery,
  // moviesQuery
} from '../graphql/queries';
import { saveLinesMutation, startCSVDownloadMutation, startPipelineMutation } from '../graphql/mutations';
import { IPointSet } from 'scorer-ui-kit/dist/LineUI';
import { API, graphqlOperation } from 'aws-amplify';

interface GraphQLResponse<T> {
  data: T;
  errors: [];
}
const { REALM } = env;

export const getFiles = async(body={}): Promise<any> => {
  const result:any =  await invoke({
    lambdaName: 'getFiles',
    body
  });
  return result;
};

// interface UploadURLBody {
//   files: {
//     filename: string;
//     fileSize: number;
//     contentType: string;
//   }[];
// }
// interface UploadURLsResponse{
//   uploadURLs: {
//     filename: string;
//     uploadURL: string;
//   }[]
// }
/*export const getUploadUrl = async({files=[]}:UploadURLBody ): Promise<UploadURLsResponse> => {
  const result:any =  await API.invoke({
    lambdaName: 'getUploadUrl',
    body: {files}
  });
  return result;
};*/

export interface LastSnapshot {
  signedUrl: string,
  time: string
}

export interface DeviceStatus {
  lastSnapshot: LastSnapshot
}

export interface Device {
  name: string;
  lid: string,
  type: string,
  tags: string[],
  deviceStatus: DeviceStatus,
}
interface DevicesResponse{
  devices: Device[]
}

export const getDevices = async( ): Promise<Device[]> => {
  const { data: {devices}} = await API.graphql(graphqlOperation(devicesQuery)) as { data: DevicesResponse};
  return devices;
};

export const getDeviceStatus = async(lid: string): Promise<DeviceStatus> => {
  const { data: {deviceStatus}} = await API.graphql(graphqlOperation(deviceStatusQuery, {deviceID: lid})) as { data: {deviceStatus: DeviceStatus }};
  return deviceStatus;
};

export interface Movie{
  DateTime: string;
  Object: string,
  RecordID: string,
  SignedImageUrl: string,
  SignedMovieUrl: string
}

 interface MovieListResponse {
 movieList : Movie[],
 nextToken: any;
}

export const getSourceFiles = async({
  deviceID,
  pageSize = '5',
  nextToken,
  jobID,
  startDate,
  endDate
}:{
  deviceID: string;
  pageSize?: string|number;
  nextToken?: any;
  jobID?: string;
  startDate?: string;
  endDate?: string;
}
): Promise<MovieListResponse> => {
  const queryParams = {
    realm: REALM,
    pageSize: pageSize.toString(),
    ...(startDate ? {startDate} : {}),
    ...(endDate ? {endDate} : {}),
    ...(nextToken ? {nextToken: JSON.stringify(nextToken)} : {}),
    ...(jobID ? {jobId: jobID} : {})
  };
  const response: MovieListResponse =  await invoke({
    lambdaName: 'getRecentMovieList',
    pathParams: {
      device: encodeURIComponent(deviceID)
    },
    queryParams
  });
  return response;
};


interface StartLogDownloadResponse {
  requestId: string;
}
interface StartLogDownloadParams {
  deviceID: string;
  jobID: string;
  startDate: string;
  endDate: string;
}
export const startDownload = async({ deviceID, jobID, startDate, endDate } : StartLogDownloadParams)
: Promise<StartLogDownloadResponse> => (
  await invoke({
    lambdaName: 'startDownload',
    payload: {
      startDateTime: startDate,
      endDateTime: endDate,
      jobId: jobID,
      logicalId: deviceID
    }
  })
);


interface LogDownloadStatusParams {
  requestId: string;
}

interface LogDownloadStatusResponse {
  status: 'Completed'|'Running';
  progress: number;
  downloadUrl?: string;
}

export const downloadStatus = async({requestId} : LogDownloadStatusParams)
: Promise<LogDownloadStatusResponse> => (
  await invoke({
    lambdaName: 'getDownloadStatus',
    payload: {
      requestId
    }
  })
);

// export const getSourceFiles = async({deviceID:string, startDate:, endDate: }): Promise<Movie[]> => {
//   const response = await API.graphql(graphqlOperation(moviesQuery, {deviceID, startDate}));
//   const {data: {list}} = response as { data: { list: Movie[], nextToken: string}};
//   return list;
// };



export const executePipeline = async(deviceID: string, analysisStartDate: string, analysisEndDate: string) => {
  const response = await API.graphql(graphqlOperation(startPipelineMutation, {deviceID, analysisStartDate, analysisEndDate}));
  const {data: {startPipeline = {}}} = response as any;
  return startPipeline;
};


export interface PipeLineExecution{
  status: 'submitted'|'failed'|'completed'
  analysisStartDate: string;
  analysisEndDate: string;
  createdDate: string;
  stages: {
    algorithmID: string;
    jobID?: null|string;
    status: null|'failed'|'completed';
    algorithmVersion: null;
  }[]
}
export const pipelineJobs = async(deviceID: string, status: string, startDate: string, endDate: string, sortDirection: string): Promise<PipeLineExecution[]> => {
  const response = await API.graphql(graphqlOperation(pipelineExecutionsQuery, {deviceID, status, startDate, endDate, sortDirection}));
  const {data: {pipelineExecutions:{list=[]}={}}={}} = response as any;
  return (list||[]).reverse();
};

export const getLines = async(deviceID: string) => {
  const response = await API.graphql(graphqlOperation(getLinesQuery, {deviceID}));
  const {data: {getLines: sl=[]}={}} = response as any;
  // console.log(sl);
  return sl;
};


export const saveLines = async(deviceID: string, lines: IPointSet[]) => {
  // console.log(lines);
  const response = await API.graphql(graphqlOperation(saveLinesMutation, {deviceID, lines}));
  const {data: {saveLines: sl=[]}={}} = response as any;
  return sl;
};


interface StartCSVDownloadParams {
  deviceID: string;
  jobID: string;
}
interface StartCSVDownloadResponse {
  startCSVDownload: {
    url: string;
  }
}

export const startCSVDownload = async({deviceID, jobID}:StartCSVDownloadParams) => {
  const {data: {startCSVDownload: {url}}} = (await API.graphql(graphqlOperation(startCSVDownloadMutation, {deviceID, jobID})) as GraphQLResponse<StartCSVDownloadResponse>);
  return {url};
};
